// Pure decision extracted from useChartManager (Fase 1 P1, bloco render-core).
// The symbol-change effect was inline in the hook (unreachable without
// renderHook); the predicate moved here so it can be unit-tested directly. The
// hook delegates — behaviour identical.
//
// Serves Directive 8: resetKey força remount total na troca de símbolo (sem
// leak de scale/hover cross-símbolo).

// ChartCanvas is canvas-based and does NOT re-render from new data props alone,
// so a symbol switch must change its React key (via resetKey++) to force a full
// remount. Bump ONLY on a real symbol TRANSITION: not on the first symbol
// (prevSymbol falsy — there is nothing to tear down) and not on a re-render with
// the same symbol (no leak to clear). Both symbols must be truthy and different.
export function shouldBumpResetKey(prevSymbol, nextSymbol) {
  return !!(prevSymbol && nextSymbol && prevSymbol !== nextSymbol);
}
